import { TagRootProps } from '@chakra-ui/react';
import {
  IQuoteRespSchema,
  NewQuoteTypeEnum,
  NewQuoteTypeEnumDisplay,
  QuoteTypeEnumDisplay,
} from '@monetize/types/app';
import { MTag } from '../../../../components/Monetize';
import { getVariantByStatus } from '../../../../utils';

interface IQuoteTypeTagProps extends TagRootProps {
  quote: IQuoteRespSchema;
}

export const QuoteTypeTag = ({ quote, ...rest }: IQuoteTypeTagProps) => {
  const variant = getVariantByStatus(quote.type);

  if (quote.newQuoteType === NewQuoteTypeEnum.EARLY_RENEWAL) {
    return (
      <MTag variant={variant} {...rest}>
        {NewQuoteTypeEnumDisplay[quote.newQuoteType]}
      </MTag>
    );
  }

  return (
    <MTag variant={variant} {...rest}>
      {QuoteTypeEnumDisplay[quote.type]}
    </MTag>
  );
};
